import React, { useState, useEffect } from "react";
import ReactImageMagnify from "react-image-magnify";
import productService from "../services/product.service";
import cartService from "../services/cart.service";
import mathService from "../services/math.service";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist, removeFromWishlist } from "../actions/wishlist.action";
import { getWishlistCartDetails } from "../actions/cart.action";
import "../components/Style/productVariationScreen.css";
import { Container, Row, Col, Button, Form, Modal, Badge } from "react-bootstrap";

function ProductScreenWithVariation() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { inCart, inWishlist, quotation } = useSelector(
    (state) => state.wishlistCartDetail
  );
  const { productId } = location?.state || {};
  const [product, setProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [requestQuotationModalVisible, setRequestQuotationModalVisible] = useState(false);
  const [quotationQuantity, setQuotationQuantity] = useState("");
  const [quotationAmount, setQuotationAmount] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [imageSize, setImageSize] = useState({ width: 1200, height: 1200 });

  // Calculate discount percentage
  const offPercent =
    selectedProduct?.stock?.mrp && selectedProduct?.stock?.selling_price
      ? mathService.discountRate(
          selectedProduct.stock.mrp,
          selectedProduct.stock.selling_price
        ).offPercent
      : 0;

  const cartWishlistDetail = (variation_id) => {
    dispatch(getWishlistCartDetails(variation_id));
  };

  const goTocart = () => {
    navigate("/cart");
  };

  const addTocart = () => {
    if (!selectedProduct) return;

    setLoading(true);
    const cartData = {
      variation_id: selectedProduct.id,
      quantity: 1,
    };

    cartService
      .addToCartHandler(cartData)
      .then((res) => {
        cartWishlistDetail(selectedProduct.id);
        setLoading(false);
      })
      .catch((error) => {
        console.log("addToCartHandler-error :: ", error);
        setLoading(false);
      });
  };

  const wishlistHandler = (id) => {
    inWishlist ? dispatch(removeFromWishlist(id)) : dispatch(addToWishlist(id));
  };

  const requestQuotationHandler = () => {
    setRequestQuotationModalVisible(true);
  };

  const submitQuotation = () => {
    if (!selectedProduct || !quotationQuantity || !quotationAmount) {
      alert("Please fill in all required fields");
      return;
    }

    const data = {
      variation_id: selectedProduct.id,
      quantity: quotationQuantity,
      amount: quotationAmount,
    };

    setLoading(true);
    cartService
      .quationHandler(data)
      .then((res) => {
        setRequestQuotationModalVisible(false);
        alert("Quote sent successfully");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        alert("Failed to send quotation");
        setLoading(false);
      });
  };

  // Load image dimensions when image changes
  useEffect(() => {
    if (selectedImage) {
      const img = new Image();
      img.onload = () => {
        setImageSize({
          width: img.width,
          height: img.height,
        });
      };
      img.src = selectedImage;
    }
  }, [selectedImage]);

  // Fetch product data
  useEffect(() => {
    if (!product && productId) {
      productService
        .getProductDetail(productId)
        .then((res) => {
          if (!res?.data) {
            throw new Error("Product data not found");
          }
          setProduct(res.data);
          setSelectedProduct(res.data?.variation[0]);
          return res.data?.variation[0];
        })
        .then((variation) => {
          if (variation) {
            cartWishlistDetail(variation.id);

            // Set initial image
            if (variation.media && variation.media.length > 0) {
              const initialImage = variation.media[0].image.image?.replace(
                /\/media\/(marketplace\/)?/g,
                ""
              );
              setSelectedImage(initialImage);
              setSelectedImageIndex(0);
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log("Error fetching product:", error);
          setLoading(false);
        });
    }
  }, [product, productId]);

  // Update selected image when product variation changes
  useEffect(() => {
    if (selectedProduct?.media && selectedProduct.media.length > 0) {
      const newImage = selectedProduct.media[0].image.image?.replace(
        /\/media\/(marketplace\/)?/g,
        ""
      );
      setSelectedImage(newImage);
      setSelectedImageIndex(0);
    }
  }, [selectedProduct]);

  const handleImageClick = (imageUrl, index) => {
    setSelectedImage(imageUrl);
    setSelectedImageIndex(index);
  };

  const ImageModule = () => {
    const [isLargeScreen, setIsLargeScreen] = useState(true);

    useEffect(() => {
      // * Hover effect work only on large screen not in tablet and mobile
      const mediaQuery = window.matchMedia("(min-width: 769px)");
      const handleChange = (e) => setIsLargeScreen(e.matches);
      setIsLargeScreen(mediaQuery.matches);
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);

    // Calculate the optimal lens size based on image dimensions
    const getLensSize = () => {
      // Make lens proportional to image size with reasonable limits
      const baseLensSize = Math.min(imageSize.width, imageSize.height) / 5;
      const lensSize = Math.max(30, Math.min(80, baseLensSize));

      return {
        width: lensSize,
        height: lensSize,
      };
    };

    return (
      <div className="product-info-gallery">
        <div className="product-info-main-image-container">
          {selectedImage &&
            (isLargeScreen ? (
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: product?.name || "Product Image",
                    isFluidWidth: true,
                    src: selectedImage,
                  },
                  largeImage: {
                    src: selectedImage,
                    width: Math.max(1200, imageSize.width * 2),
                    height: Math.max(1200, imageSize.height * 2),
                  },
                  lensStyle: {
                    backgroundColor: "rgba(0,0,0,.3)",
                    border: "1px solid #ccc",
                  },
                  isHintEnabled: true,
                  shouldHideHintAfterFirstActivation: false,
                  enlargedImageContainerStyle: {
                    background: "#fff",
                    zIndex: 9,
                  },
                  enlargedImageContainerDimensions: {
                    width: "100%",
                    height: "100%",
                  },
                  hoverDelayInMs: 100,
                  hoverOffDelayInMs: 150,
                  lensSize: getLensSize(),
                  imageClassName: "product-info-main-image",
                }}
              />
            ) : (
              <img
                src={selectedImage}
                alt="Product"
                className="product-info-main-image"
              />
            ))}
        </div>
        <div className="thumbnail-gallery">
          {selectedProduct?.media?.map((media, index) => {
            const imageURL = media.image.image?.replace(
              /\/media\/(marketplace\/)?/g,
              ""
            );
            return (
              <div
                key={index}
                className={`thumbnail-item ${
                  index === selectedImageIndex ? "active" : ""
                }`}
                onClick={() => handleImageClick(imageURL, index)}
              >
                <img src={imageURL} alt={`Product view ${index + 1}`} />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const PriceSection = () => {
    return (
      <div className="product-info-price">
        <div className="product-info-price-details">
          <span className="original-price">MRP: ₹{selectedProduct?.stock?.mrp}</span>
          <Badge bg="success" className="discount-badge">{offPercent}% off</Badge>
        </div>
        <div className="info-selling-price">₹{selectedProduct?.stock?.selling_price}</div>
      </div>
    );
  };

  const Variation = () => {
    if (!product || !product.variation) return null;

    return (
      <div className="product-info-variations">
        <h6 className="variation-title">
          {product.variation.length > 1
            ? product.variation[0]?.variation_name?.name
            : "One Size"}
        </h6>
        <div className="variation-options">
          {product.variation.map((res, key) => (
            <div
              key={key}
              className={`variation-option ${res.id === selectedProduct?.id ? "active" : ""}`}
              onClick={() => {
                setSelectedProduct(res);
                cartWishlistDetail(res?.id);
              }}
            >
              {product.variation.length > 1 && (
                <div className="variation-value">{res?.variation_name?.value}</div>
              )}
              <div className="variation-weight">{res?.stock?.product_weight + res?.stock?.unit}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const OutOfStock = () => {
    return (
      <div className="out-of-stock-banner">
        Out of stock
      </div>
    );
  };

  const QuoteDetails = () => {
    return (
      <div className="quote-details-card">
        <h5>Your Quote:</h5>
        <div className="quote-info">
          <span>Quantity: {quotation?.quotation?.quantity}</span>
          <span>Amount: ₹{quotation?.quotation?.amount}</span>
        </div>
      </div>
    );
  };

  const Description = ({ numberOfLines = undefined }) => {
    if (!product?.description) return null;

    const splitByPeriod = product.description.split(/\n\n|:/);
    const descriptionText = splitByPeriod
      ?.flatMap((point) => point.split(/\.\n/))
      .slice(0, numberOfLines)
      .map((point, index) => {
        if (!point.trim()) return null;
        return (
          <li key={index}>
            {point.trim()}
          </li>
        );
      })
      .filter(Boolean);

    return (
      <div className={`product-info-description ${numberOfLines ? "truncated" : "full"}`}>
        <h4 className="section-title">About Product</h4>
        <ul className="description-list">{descriptionText}</ul>
      </div>
    );
  };

  const notReady = () => {
    alert("This feature is not available now.");
  };

  if (!product && loading) {
    return <Loader loading={true} />;
  }

  return (
    <>
      <Loader loading={loading} />
      
      {/* Quotation Modal */}
      <Modal 
        show={requestQuotationModalVisible} 
        onHide={() => setRequestQuotationModalVisible(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Quote Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter your required quantity"
                min="10"
                value={quotationQuantity}
                onChange={(e) => setQuotationQuantity(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Quotation price/quantity</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter your quotation price"
                min="0"
                value={quotationAmount}
                onChange={(e) => setQuotationAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setRequestQuotationModalVisible(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitQuotation}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Desktop View */}
      <Container fluid className="product-info-view-desktop">
        <Row className="product-info-main-container">
          <Col md={5} className="product-info-image-col">
            <ImageModule />
          </Col>
          
          <Col md={4} className="product-info-details-col">
            <div className="product-info-header">
              <div className="product-info-title-section">
                <h2 className="product-info-title">{product?.name}</h2>
                <button 
                  className={`wishlist-button ${inWishlist ? 'active' : ''}`}
                  onClick={() => selectedProduct && wishlistHandler(selectedProduct.id)}
                >
                  <i className={`fas fa-heart`} />
                </button>
              </div>
              <h6 className="product-info-brand">{product?.brand?.name}</h6>
              {product?.product_type === 1 ? (
                <PriceSection />
              ) : (
                <div className="quotation-message">Please send your quotation</div>
              )}
            </div>
            
            <Variation />
            
            <hr className="section-divider" />
            
            <Description numberOfLines={4} />
          </Col>
          
          <Col md={3} className="product-info-actions-col">
            <div className="product-info-action-buttons">
              {!selectedProduct ? null : selectedProduct.stock?.total_stock === 0 ? (
                <OutOfStock />
              ) : (
                <>
                  {inCart ? (
                    <Button variant="primary" className="action-button info-cart-button" onClick={goTocart}>
                      <i className="fas fa-shopping-cart me-2"></i>Go to Cart
                    </Button>
                  ) : (
                    <Button variant="primary" className="action-button info-cart-button" onClick={addTocart}>
                      <i className="fas fa-cart-plus me-2"></i>Add to Cart
                    </Button>
                  )}
                  
                  <Button variant="outline-secondary" className="action-button" onClick={notReady}>
                    <i className="fas fa-star me-2"></i>Add Review
                  </Button>
                  
                  <Button variant="outline-secondary" className="action-button" onClick={notReady}>
                    <i className="fas fa-question-circle me-2"></i>Ask Question
                  </Button>
                </>
              )}
              
              {quotation?.quotation && user ? (
                <QuoteDetails />
              ) : (
                <Button variant="outline-primary" className="action-button quote-button" onClick={requestQuotationHandler}>
                  <i className="fas fa-file-invoice me-2"></i>Request Quotation
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      {/* Mobile View */}
      <Container fluid className="product-info-view-mobile">
        <Row>
          <Col xs={12}>
            <ImageModule />
          </Col>
          
          <Col xs={12} className="mobile-product-info-details">
            <div className="product-info-header">
              <div className="product-info-title-section">
                <h2 className="product-info-title">{product?.name}</h2>
                <button 
                  className={`wishlist-button ${inWishlist ? 'active' : ''}`}
                  onClick={() => selectedProduct && wishlistHandler(selectedProduct.id)}
                >
                  <i className={`fas fa-heart`} />
                </button>
              </div>
              <h6 className="product-info-brand">{product?.brand?.name}</h6>
              {product?.product_type === 1 ? (
                <PriceSection />
              ) : (
                <div className="quotation-message">Please send your quotation</div>
              )}
            </div>
            
            <Variation />
            
            <hr className="section-divider" />
            
            <div className="mobile-product-info-actions">
              {!selectedProduct ? null : selectedProduct.stock?.total_stock === 0 ? (
                <OutOfStock />
              ) : (
                <>
                  {inCart ? (
                    <Button variant="primary" className="action-button info-cart-button w-100 mb-2" onClick={goTocart}>
                      <i className="fas fa-shopping-cart me-2"></i>Go to Cart
                    </Button>
                  ) : (
                    <Button variant="primary" className="action-button info-cart-button w-100 mb-2" onClick={addTocart}>
                      <i className="fas fa-cart-plus me-2"></i>Add to Cart
                    </Button>
                  )}
                  
                  <div className="d-flex justify-content-between mb-2">
                    <Button variant="outline-secondary" className="action-button flex-grow-1 me-2" onClick={notReady}>
                      <i className="fas fa-star me-2"></i>Review
                    </Button>
                    
                    <Button variant="outline-secondary" className="action-button flex-grow-1" onClick={notReady}>
                      <i className="fas fa-question-circle me-2"></i>Ask
                    </Button>
                  </div>
                </>
              )}
              
              {quotation?.quotation && user ? (
                <QuoteDetails />
              ) : (
                <Button variant="outline-primary" className="action-button quote-button w-100" onClick={requestQuotationHandler}>
                  <i className="fas fa-file-invoice me-2"></i>Request Quotation
                </Button>
              )}
            </div>
          </Col>
        </Row>
        
        <hr className="section-divider" />
        
        <Row>
          <Col xs={12}>
            <Description />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProductScreenWithVariation;